import React from 'react';
import 'swiper/swiper-bundle.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import { Call } from '../types.ts';
import { formatDateTime, safeFormatDateTime } from '@/utils/dateUtils.ts';
import { landingYoutube, popupToast, sendEvent } from '@/api/nativeBridge.ts';

interface AnalyzeSwiperSectionProps {
  callList: Call[]; // 여기에 callList 배열 타입을 정의
}
interface YoutubeItems {
  videoId: string;
  markSrc: string;
  imgSrc: string;
  imgAlt: string;
  title: string;
  desc: string[];
}

interface SlideItem {
  callId: string;
  name: string;
  callEndTime: string;
  callStartTime: string;
  pushBody: string;
  youtubeItems: YoutubeItems[];
}

const AnalyzeSwiperSection: React.FC<AnalyzeSwiperSectionProps> = ({
  callList,
}) => {
  // 실제로는 API 호출 결과나 props 등을 통해 데이터를 받아올 수 있지만,
  // 여기서는 예시로 고정된 데이터를 넣어둡니다.
  console.log('SEARCH ::A ::', callList);
  const SlideItems: SlideItem[] = callList.map((call) => ({
    callId: call.callId,
    name: call.name || '',
    callEndTime: call.callEndTime,
    callStartTime: call.callStartTime,
    pushBody: call.pushBody,
    youtubeItems: call.searchResult.map((result) => ({
      videoId: result.youtube.contents?.[0]?.videoId,
      markSrc: 'res/img/analyze_card_mark.webp',
      imgSrc: result.youtube.contents?.[0]?.isShort
        ? result.youtube.contents?.[0]?.thumbnailUrl
        : '/res/img/analyze_card_empty.webp',
      imgAlt: result.youtube.contents?.[0]?.isShort ? '유튜브 썸네일' : 'empty',
      title: result.youtube.query,
      desc: result.youtube.tags || result.youtube.contents || [],
    })),
  }));

  const clickYoutube = (
    videoId: string,
    itemIndex: number,
    slideIndex: number,
  ) => {
    if (videoId) {
      landingYoutube(
        videoId,
        (itemIndex + 1).toString(),
        (slideIndex + 1).toString(),
      );
    } else {
      popupToast(1, '유튜브 쇼츠가 존재하지 않습니다.');
    }
  };

  return (
    <Swiper
      className="analyzeSwiper"
      slidesPerView={'auto'}
      spaceBetween={28}
      grabCursor
      pagination={{
        el: '.analyzeSwiper .swiper-pagination',
        clickable: true,
        type: 'fraction',
      }}
      navigation={{
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }}
      modules={[Pagination, Navigation]}
    >
      {SlideItems.map((slide, slideIndex) => (
        <SwiperSlide key={slideIndex}>
          <div className="analyze-box">
            <div className="analyze-box__title-wrap">
              <p className="title">{slide.pushBody}</p>
              <p className="user-info">
                <span
                  className="user"
                  onClick={() => {
                    sendEvent('SEND_LOG', {
                      type: 'GA4',
                      key: 'AI검색_지난대화',
                      message: '통화이력 더보기',
                    });
                    sendEvent('GO_DISCOVER_SUMMARY', { callId: slide.callId });
                  }}
                >
                  {/*<img*/}
                  {/*    src='https://dummyimage.com/20x20/000000/fff'*/}
                  {/*    alt='사용자 프로필 아이콘 이미지'*/}
                  {/*    className='mr6'*/}
                  {/*/>*/}
                  <em>{slide.name}</em>
                  <span>&nbsp;님과 통화</span>
                </span>
                <span className="time">
                  {safeFormatDateTime(slide.callStartTime)}
                </span>
              </p>
            </div>
          </div>
          {slide.youtubeItems.map((youtubeItem, itemIndex) => (
            <div
              key={`${slideIndex}_${itemIndex}`}
              onClick={() =>
                clickYoutube(youtubeItem.videoId, itemIndex, slideIndex)
              }
            >
              <div className="item">
                <div className="thumb">
                  <span className="bg"></span>
                  <img
                    src={youtubeItem.markSrc}
                    alt="SHORTS"
                    className="mark"
                  />
                  <img
                    src={youtubeItem.imgSrc
                      .replace('/vi/', '/vi_webp/')
                      .replace('.jpg', '.webp')}
                    alt={youtubeItem.imgAlt}
                    className="analyze-img"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = youtubeItem.imgSrc;
                    }}
                  />
                </div>
                <div className="title-box">
                  <div className="title">{youtubeItem.title}</div>
                  <div className="desc">
                    {youtubeItem.desc.map((line, lineIndex) => (
                      <p key={lineIndex}>{line}</p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </SwiperSlide>
      ))}
      <div className="swiper-controll-wrap">
        <span className="swiper-button-prev"></span>
        <span className="swiper-pagination"></span>
        <span className="swiper-button-next"></span>
      </div>
    </Swiper>
  );
};

export default AnalyzeSwiperSection;
